import format from 'date-fns/format'
import parseISO from 'date-fns/parseISO'
import nl from 'date-fns/locale/nl'
import en from 'date-fns/locale/en-GB'
import ro from 'date-fns/locale/ro'
import i18n from 'src/i18n'
import {
  DEFAULT_DATE_FORMAT,
  DEFAULT_DATETIME_FORMAT,
  FRIENDLY_DATE_FORMAT,
  FRIENDLY_DATETIME_FORMAT
} from 'src/config/dateUtils'

const localeMapping = {
  en: en,
  nl: nl,
  ro: ro,
  default: en,
}

export default {
  install (Vue) {
    let app = new Vue({
      i18n,
      methods: {
        formatDate (date, dateFormat = DEFAULT_DATETIME_FORMAT) {
          const appDateFormat = localStorage.getItem('app_date_format')
          const appHourFormat = localStorage.getItem('app_hour_format')

          if (!date) {
            return '- -'
          }
          let dateToFormat = date
          if (typeof date === 'string') {
            dateToFormat = parseISO(date)
          }

          if (appDateFormat && appHourFormat) {
            if (dateFormat === DEFAULT_DATETIME_FORMAT || dateFormat === FRIENDLY_DATETIME_FORMAT) {
              dateFormat = `${appDateFormat} ${appHourFormat}`
            } else if (dateFormat === DEFAULT_DATE_FORMAT || dateFormat === FRIENDLY_DATE_FORMAT) {
              dateFormat = appDateFormat
            }
          }
          const localeStr = localStorage.getItem('app_locale') || 'en'
          const locale = localeMapping[localeStr] || localeMapping.default
          return format(dateToFormat, dateFormat, {locale})
        },
      }
    })
    Vue.prototype.$formatDate = app.formatDate
  }
}
